import { SETTINGS, BLOB_TYPES } from '@constants';

const { cdnUrl } = SETTINGS;
const { logo, pdf, background, icon } = BLOB_TYPES;

const capitalizeFirstLetter = word => {
    const firstLetter = word[0];
    const remainingLetters = word.slice(1);

    return firstLetter.toUpperCase() + remainingLetters.toLowerCase();
};

export const formatFirmNameForEndpoints = firmShortName => {
    if (!firmShortName) return null;

    // If multiple words in the firm name
    if (firmShortName.includes(' ')) {
        return firmShortName
                .split(' ')
                .map(word => word && capitalizeFirstLetter(word))
                .join('-');
    }

    return capitalizeFirstLetter(firmShortName);
};

const _getImageFile = (fileType, formattedName) => {
    switch (fileType) {
        case logo:
            return `${formattedName}_logo.svg`;
        case icon:
            return `${formattedName}_icon.svg`;
        case background:
            return `${formattedName}_background.png`;
        case pdf:
            return `${formattedName}_document.pdf`;
        default:
            return 'Not found';
    }
};

export const generateStorageBlobUrl = (fileType, firmOrProfileShortName) => {
    const formattedName = formatFirmNameForEndpoints(firmOrProfileShortName);
    const fileNameWithExtension = _getImageFile(fileType, formattedName);

    if (fileType === pdf) {
        return `${cdnUrl}/tp-legal-documents/${fileNameWithExtension}`;
    } else {
        return `${cdnUrl}/tp-images/${fileType}/${fileNameWithExtension}`;    
    }
};

export const generateSlideImageUrl = name => {
    return `${cdnUrl}/tp-images/slides/${name}`;
};
